<template>
  <div
          v-if="calculation.id"
          class="py-3 calcContainer"
          :class="{
            'black':$vuetify.theme.dark,
            'grey':$vuetify.theme.light,
            'lighten-2':$vuetify.theme.dark,
            'lighten-3':$vuetify.theme.light
          }"
  >
    <v-card :loading="calculationIsLoading" elevation="0">
      <v-layout class="pa-3 pt-0">
        <v-flex xs12>
          <v-row>
            <v-col cols="6" class="d-flex align-end text-right py-2 pb-1" sm="12" md="6">
              <h1>{{ calculation.name }}</h1>
            </v-col>
            <v-col cols="6" class="d-flex justify-end text-right py-2 pb-1" sm="12" md="6">
              <span class="d-inline-block pr-3 pt-1 pr-md-7 pl-md-4">
                <span class="text-caption grey--text text-no-wrap">{{ $t('common.total_sum') }}</span><br/>
                <strong>{{ formatCurrency(calculation.total_sum) }}</strong>
              </span>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                      :disabled="!calculation.items.length"
                      class="mb-0 mr-0"
                      @click="transformToCart(calculation);"
                      color="primary"
                      elevation="0"
                      min-width="48"
                      min-height="48"
                      v-on="on"
                  >
                    <v-icon small>fa-cart-arrow-down</v-icon>
                  </v-btn>
                </template>
                <span
                >{{$t('viewCalculations.return_to_cart')}}</span
                >
              </v-tooltip>


              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                      :disabled="!calculation.items.length"
                      elevation="0"
                      min-width="48"
                      min-height="48"
                      class="mb-0 ml-3 px-0"
                      target="_blank"
                      :href="`${$apiURL}/calculation/${calculation.id}/print`"
                      v-on="on"
                  >
                    <v-icon small>fa-print</v-icon>
                  </v-btn>
                </template>
                <span
                >{{$t('common.print')}}</span
                >
              </v-tooltip>

            </v-col>
          </v-row>
          <v-divider class="pt-0 mt-1 pb-4"></v-divider>

          <!-- таблица с деталями-->
          <multi-cart-parts-table
                  v-if="calculationType=='parts'"
                  :is-calculation="true"
                  :data="calculation.items.filter(item=>item.type=='part')"
                  :show-footer="true"
                  id="tableCart"
          />
          <!-- таблица с работами-->
          <v-data-table
                  v-if="calculationType=='repairtimes'"
                  :headers="[
                                              {text: $t('common.title'), value: 'name', class: 'text-no-wrap'},
                                              {text: $t('common.repairtime'), value: 'time', align: 'end', class: 'text-no-wrap'},
                                              {text: $t('common.amount'), value: 'amount', align: 'end', width:'200px', class: 'text-no-wrap'},
                                              {text: $t('common.price'), value: 'price',  align: 'end', class: 'text-no-wrap'},
                                              {text: $t('common.total_sum'),  align: 'end', class: 'text-no-wrap'},

                                          ]"
                  :items="calculation.items.filter(item=>item.type=='repairtime')"
                  hide-default-footer
                  dense
                  class="lighten-5 ma-0 elevation-0"
                  :id="fixedHeight ? 'fixedTableCart' : 'tableCart'"
                  height = "auto"
                  :options="{
                    itemsPerPage: 1000
                  }"
          >
            <template v-slot:item="items">
              <tr>
                <td class="text-left">{{ items.item.name }}</td>
                <td class="text-right">{{ items.item.time }}</td>
                <td class="text-right" style="width: 200px;">
                  <v-container >
                    <v-row class="">
                      <v-col cols="12" sm="6" md="4">
                        {{ items.item.amount }}
                      </v-col>
                    </v-row>
                  </v-container>
                </td>
                <td class="text-right">{{ formatCurrency(items.item.price) }}</td>
                <td class="text-right">{{formatCurrency((parseFloat(items.item.price*items.item.amount)).toFixed(2))}}</td>
              </tr>
            </template>
            <template v-slot:body.append="items">

              <tr class="text-xs-left">
                <td colspan="2" class="text-sm-right"></td>
                <td class="text-center">
                  <strong>{{Object.values(items.items).reduce((sum, item) => parseInt(item.amount) + parseInt(sum), 0)}}</strong>
                </td>
                <td class="text-sm-right"></td>
                <td class="text-sm-right text-no-wrap">
                  <strong>{{formatCurrency(Object.values(items.items).reduce((sum, item) => (parseFloat(item.price*item.amount) + parseFloat(sum)).toFixed(2), 0))}}</strong>
                </td>
              </tr>
            </template>
            <template v-slot:no-data>
              {{ $t("common.no_data_available") }}
            </template>
            <template v-slot:no-results>
              {{ $t("common.no_data_available") }}
            </template>
          </v-data-table>
          <!-- таблица с работами и деталями-->
          <v-data-table
                  v-if="calculationType=='summary'"
                  :headers="[
                                              {text: '', value: 'data-table-expand'},
                                              {text: $t('common.title'), value: 'name', class: 'text-no-wrap'},
                                              {text: $t('common.repairtime'), value: 'time', align: 'end', class: 'text-no-wrap'},
                                              {text: $t('common.amount'), value: 'amount', align: 'end', width:'200px', class: 'text-no-wrap'},
                                              {text: $t('common.price'), value: 'price',  align: 'end', class: 'text-no-wrap'},
                                              {text: $t('common.total_sum'), align: 'end', class: 'text-no-wrap'},

                                          ]"
                  :items="calculation.items.filter(item=>item.type=='repairtime')"
                  :expanded="expanded"
                  show-expand
                  class="elevation-0 mb-3"
                  hide-default-footer
                  :options="{
                    itemsPerPage: 1000
                  }"
          >
            <template v-slot:item="items">
              <tr>
                <td class="pa-0 pl-1">
                  <v-btn depressed fab x-small @click="toggleExpanded(items.item)" v-if="calculation.items.filter(el=>el.type=='part' && el.repairtime_id_in_cart==items.item.id).length">
                    <v-icon v-if="expanded.includes(items.item)">mdi-chevron-up</v-icon>
                    <v-icon v-else>mdi-chevron-down</v-icon>
                  </v-btn>
                </td>
                <td class="text-left">
                  <v-icon x-small>fa-tools</v-icon> {{ items.item.name }}<br/>
                  <template v-if="calculation.items.filter(el=>el.type=='part' && el.repairtime_id_in_cart==items.item.id).length">
                    <!-- Деталей:  -->
                    <span class="mr-5 grey--text text--lighten-1">
                    {{ $t('componentMultiCart.parts_num') }}:
                    {{Object.values(calculation.items.filter(el=>el.type=='part' && el.repairtime_id_in_cart==items.item.id)).reduce((sum, it) => parseInt(it.amount) + parseInt(sum), 0)}}
                  </span>
                    <!-- на сумму:  -->
                    <span class="ml-5 grey--text text--lighten-1">
                    {{ $t('componentMultiCart.on_sum') }}:
                    {{formatCurrency(Object.values(calculation.items.filter(el=>el.type=='part' && el.repairtime_id_in_cart==items.item.id)).reduce((sum, item) => (parseFloat(item.price*item.amount) + parseFloat(sum)).toFixed(2), 0))}}
                  </span>
                  </template>
                </td>
                <td class="text-right">{{ items.item.time }}</td>
                <td class="text-right" style="width: 200px;">
                  {{ items.item.amount }}
                </td>
                <td class="text-right">{{ formatCurrency(items.item.price) }} </td>
                <td class="text-right">{{formatCurrency((parseFloat(items.item.price*items.item.amount)).toFixed(2))}}</td>
              </tr>
            </template>
            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length" class="px-0">
                <multi-cart-parts-table :data="calculation.items.filter(el=>el.type=='part' && el.repairtime_id_in_cart==item.id)" :id="fixedHeight ? 'fixedTableCart' : 'tableCart'" height = "auto" :is-calculation="true"/>
              </td>
            </template>
            <template v-slot:body.append="items">
              <tr>
                <td class="pa-0 pl-1">
                  <v-btn depressed fab x-small @click="showUnattachedParts = !showUnattachedParts" v-if="calculation.items.filter(el=>el.type=='part' && el.repairtime_id_in_cart==null).length >0">
                    <v-icon v-if="showUnattachedParts">mdi-chevron-up</v-icon>
                    <v-icon v-else>mdi-chevron-down</v-icon>
                  </v-btn>
                </td>
                <td>
                  <template v-if="calculation.items.filter(el=>el.type=='part' && el.repairtime_id_in_cart==null).length">
                    <i>{{$t('componentMultiCart.parts_without_repairtimes')}}</i>
                    <br/>
                    <!-- Деталей:  -->
                    <span class="mr-5 grey--text text--lighten-1">
                    {{ $t('componentMultiCart.parts_num') }}:
                    {{Object.values(calculation.items.filter(el=>el.type=='part' && el.repairtime_id_in_cart==null)).reduce((sum, it) => parseInt(it.amount) + parseInt(sum), 0)}}
                  </span>
                    <!-- на сумму:  -->
                    <span class="ml-5 grey--text text--lighten-1">
                    {{ $t('componentMultiCart.on_sum') }}:
                    {{formatCurrency(Object.values(calculation.items.filter(el=>el.type=='part' && el.repairtime_id_in_cart==null)).reduce((sum, it) => (parseFloat(it.price*it.amount) + parseFloat(sum)).toFixed(2), 0))}}
                  </span>
                  </template>
                  <template v-else>
                    <i>{{$t('componentMultiCart.none_parts_without_repairtimes')}}</i>
                  </template>
                </td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr v-if="showUnattachedParts && calculation.items.filter(el=>el.type=='part' && el.repairtime_id_in_cart==null).length">
                <td colspan="6" class="pa-0 ma-0">
                  <multi-cart-parts-table :data="calculation.items.filter(el=>el.type=='part' && el.repairtime_id_in_cart==null)" :id="fixedHeight ? 'fixedTableCart' : 'tableCart'" :height = "tableHeight" :is-calculation="true"/>
                </td>
              </tr>
            </template>
            <template v-slot:no-data>
              {{ $t("common.no_data_available") }}
            </template>
            <template v-slot:no-results>
              {{ $t("common.no_data_available") }}
            </template>
          </v-data-table>
          <template>
            <v-row class="pr-5 mb-2">
              <v-col cols="3">
                <p class="ma-0 mt-2">
                      <span class="text-caption"
                      >{{ $t("common.customer") }}:</span
                      >
                  <span
                      v-if="calculation.customer"
                  >
                        {{ calculation.customer.last_name }}
                        {{ calculation.customer.first_name }}
                        {{ calculation.customer.patronymic }}
                      </span>
                  <span v-else>
                        -
                      </span>
                </p>
                <p
                    class="ma-0"
                    v-if="calculation.customer && calculation.customer.is_company == 1"
                >
                      <span class="text-caption"
                      >{{ $t("common.legal_name") }}:</span
                      >
                  <strong

                  >{{
                      calculation.customer.is_company == 1
                          ? "[" + calculation.customer.legal_name + "]"
                          : ""
                    }}</strong
                  >
                </p>
                <p class="ma-0" >
                  <span class="text-caption">{{ $t("common.car") }}:</span>
                  <span>
                        {{ calculation.car ? calculation.car.name : "" }}
                      </span>
                  <beauty-car-number
                      class="d-inline-block ml-2"
                      v-if="calculation.car && calculation.car.car_number"
                      :number="calculation.car.car_number"
                  >
                  </beauty-car-number>
                  <span v-if="!calculation.car" class="">-</span>
                </p>
              </v-col>
              <v-col cols="3">
                <p class="ma-0 mt-2">
                  <span class="text-caption d-block"
                  >{{ $t("common.responsible") }}:</span
                  >
                  {{
                    calculation.possessor && calculation.possessor.name
                  }}
                </p>
              </v-col>
            </v-row>
          </template>
        </v-flex>
      </v-layout>
    </v-card>
  </div>
</template>
<script>
import {required, email, sameAs, minLength,} from "vuelidate/lib/validators";
import {mapState} from 'vuex';
import {mapFields} from 'vuex-map-fields';
import MultiCartPartsTable from "../common/MultiCartPartsTable";
import CommonMixin from "@/mixins/common";
import BeautyCarNumber from "@/components/common/BeautyCarNumber.vue";

export default {
    components: {BeautyCarNumber, MultiCartPartsTable},
    mixins: [CommonMixin],
    data: () => ({
    expanded:[],
    showUnattachedParts:false,
    tableHeight: 'auto',
    fixedHeight: false,
  }),


  mounted() {

  },
  computed: {
    ...mapFields("site", ['lang']),
    ...mapFields('cart', [
      'calculations',
      'calculation',
      'calculationIsLoading']
    ),
    calculationType(){
      let partsNum = this.calculation.items.filter(it => it.type === 'part').length; //число деталей в заказе
      let repairtimesNum = this.calculation.items.filter(it => it.type === 'repairtime').length; //число работ в заказе

      if (partsNum > 0 && repairtimesNum > 0) return 'summary';
      if (partsNum > 0 && repairtimesNum < 1) return 'parts';
      if (partsNum < 1 && repairtimesNum > 0) return 'repairtimes';
      return null;
    },
  },
  methods: {
      showGarageForSelectCar(){},
      toggleExpanded(item){
          if(this.expanded.filter(i => parseInt(i.id) === parseInt(item.id)).length){
              this.expanded = this.expanded.filter(i => i.id !== item.id);
          } else {
              this.expanded.push(item)
          }
      },
      transformToCart(calculation){
          this.$store.dispatch('cart/transformCalculationToCart', calculation).then((data) => {
              this.$router.push({ name: 'search'});
          });
      },
      printCalculation(calculation){

      }
  },
}
</script>

<style lang="css">

</style>